import React from "react";
import { Restricted } from "components/auth";
import { NotAllowedPage } from "components/page";

const withPermissions = permissions => Page => {
  const PageWithPermissions = props => (
    <Restricted permissions={permissions} fallback={<NotAllowedPage />}>
      <Page {...props} />
    </Restricted>
  );

  const pageName = Page.displayName || Page.name || "Unknown";
  PageWithPermissions.displayName = `WithPermissions(${pageName})`;

  return PageWithPermissions;
};

export default withPermissions;
